import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Kbd } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SearchInput = ({ value, onChange }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <Styles.Container>
      <MagnifyingGlassIcon size={20} color={theme.colors.border.default} />
      <Styles.Input
        ref={inputRef}
        type="text"
        placeholder={t('Buscar páginas, envíos, devoluciones, ajustes...')}
        value={value}
        onChange={e => onChange(e.target.value)}
        data-testid="global-search-input"
      />
      <Kbd>ESC</Kbd>
    </Styles.Container>
  )
}

export default SearchInput
